import React, { useEffect, useState } from 'react';
import api from './api';
import './OnlineMetrics.css';

const OnlineMetrics = ({ onBack }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    api.getOnlineMetrics(30).then((result) => {
      if (active) setData(result);
    }).finally(() => {
      if (active) setLoading(false);
    });

    return () => {
      active = false;
    };
  }, []);

  const today = data?.today || {};

  return (
    <div className="dart-league-dashboard training-menu-container online-metrics-page">
      <header className="training-menu-header online-metrics-header">
        <div className="training-header-top online-metrics-header-top">
          <button className="training-back-btn online-metrics-back" onClick={onBack}>← Volver</button>
        </div>
        <div className="online-metrics-kicker">Panel privado · Juanmi</div>
        <h1>Métricas online</h1>
        <p>Actividad global de la sala</p>
      </header>

      <main className="training-menu-content online-metrics-content">
        {loading && <p className="online-metrics-message">Cargando métricas...</p>}
        {!loading && !data && <p className="online-metrics-message">No se han podido cargar las métricas.</p>}
        {!loading && data && (
          <>
            <section className="online-metrics-summary" aria-label="Resumen de hoy">
              <div className="online-metric-card users"><span className="online-metric-label">Usuarios únicos hoy</span><strong className="online-metric-value">{today.uniqueUsers || 0}</strong><span className="online-metric-note">Personas que han entrado</span></div>
              <div className="online-metric-card started"><span className="online-metric-label">Partidas iniciadas</span><strong className="online-metric-value">{today.gamesStarted || 0}</strong><span className="online-metric-note">Salas que comenzaron</span></div>
              <div className="online-metric-card finished"><span className="online-metric-label">Partidas finalizadas</span><strong className="online-metric-value">{today.gamesFinished || 0}</strong><span className="online-metric-note">Resultados guardados</span></div>
            </section>

            <section className="online-metrics-history" aria-label="Evolución diaria">
              <div className="online-metrics-section-heading"><div><span className="online-metrics-kicker">Seguimiento</span><h2>Evolución diaria</h2></div><span className="online-metrics-period">Últimos 30 días</span></div>
              {data.days.length === 0 ? <p className="online-metrics-message">Aún no hay datos diarios.</p> : (
                <div className="online-metrics-table-wrap">
                  <table className="online-metrics-table">
                    <thead><tr><th>Día</th><th>Usuarios</th><th>Iniciadas</th><th>Finalizadas</th></tr></thead>
                    <tbody>{data.days.map((day) => (
                      <tr key={day.day}><td>{day.day}</td><td>{day.uniqueUsers}</td><td>{day.gamesStarted}</td><td>{day.gamesFinished}</td></tr>
                    ))}</tbody>
                  </table>
                </div>
              )}
            </section>
          </>
        )}
      </main>
    </div>
  );
};

export default OnlineMetrics;